<template>
<div class="chapter">
<div class="inner_page">
<div id="eBook4242.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="Title para-style-override-1" id="toc_marker-1"><span class="char-style-override-1"><img alt="SingingattheGatesHCFront.jpg" class="image" src="images/SingingattheGatesHCFro_fmt.jpeg" width="98%"/></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook4242.vue?4c769f70